import { useRef, useState } from "react";
import { toast } from "sonner";
import { X, Upload } from "lucide-react";
import { inputCls, labelCls } from "./SectionCard";
import { api, photoUrl, uploadFiles, formatApiError } from "../../api";

export default function RecordFormModal({ vehicle, kind, modal, setModal, onSaved, testid }) {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);
  const d = modal.data;

  const save = async (e) => {
    e.preventDefault();
    const payload = {
      type: kind === "bakim" ? "servis" : d.type,
      date: d.date, title: d.title, description: d.description,
      km: d.km === "" ? null : Number(d.km), cost: d.cost === "" ? null : Number(d.cost),
      photos: d.photos,
      ...(kind === "bakim"
        ? { part: d.part || null, servis: d.servis || null }
        : { zone: d.zone || null, damage_type: d.damage_type || null, severity: d.severity }),
    };
    try {
      const res = modal.record
        ? await api.put(`/my-vehicles/${vehicle.id}/records/${modal.record.id}`, payload)
        : await api.post(`/my-vehicles/${vehicle.id}/records`, payload);
      onSaved(res.data);
      setModal(null);
      toast.success(modal.record ? "Kayıt güncellendi" : "Kayıt eklendi");
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const setField = (k, val) => setModal((m) => ({ ...m, data: { ...m.data, [k]: val } }));

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm" onClick={() => setModal(null)}>
      <div data-testid={`${testid}-modal`} className="w-full max-w-lg max-h-[90vh] overflow-y-auto rounded-2xl bg-slate-900 border border-white/10 shadow-2xl p-6"
        onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-5">
          <h3 className="text-lg font-bold text-white">{modal.record ? "Kaydı Düzenle" : "Kayıt Ekle"}</h3>
          <button data-testid={`${testid}-modal-close`} onClick={() => setModal(null)} className="text-slate-400 hover:text-white"><X className="w-5 h-5" /></button>
        </div>
        <form onSubmit={save} className="space-y-4">
          <div className="grid grid-cols-2 gap-4">
            <div><label className={labelCls}>İşlem Tarihi *</label>
              <input data-testid={`${testid}-form-date`} required type="date" value={d.date} onChange={(e) => setField("date", e.target.value)} className={inputCls} /></div>
            <div><label className={labelCls}>Kilometre</label>
              <input data-testid={`${testid}-form-km`} type="number" min="0" value={d.km} onChange={(e) => setField("km", e.target.value)} className={inputCls} /></div>
          </div>
          {kind === "bakim" ? (
            <>
              <div><label className={labelCls}>Yapılan İşlem *</label>
                <input data-testid="bakim-form-title" required value={d.title} onChange={(e) => setField("title", e.target.value)} className={inputCls} placeholder="Periyodik bakım, yağ değişimi..." /></div>
              <div className="grid grid-cols-2 gap-4">
                <div><label className={labelCls}>Değiştirilen Parça</label>
                  <input data-testid="bakim-form-part" value={d.part} onChange={(e) => setField("part", e.target.value)} className={inputCls} placeholder="Fren balatası..." /></div>
                <div><label className={labelCls}>Servis / Usta</label>
                  <input data-testid="bakim-form-servis" value={d.servis} onChange={(e) => setField("servis", e.target.value)} className={inputCls} placeholder="Yetkili servis..." /></div>
              </div>
            </>
          ) : (
            <>
              <div className="grid grid-cols-2 gap-4">
                <div><label className={labelCls}>Hasar Bölgesi</label>
                  <input data-testid="hasar-form-zone" value={d.zone} onChange={(e) => setField("zone", e.target.value)} className={inputCls} placeholder="Sağ ön kapı..." /></div>
                <div><label className={labelCls}>Hasar Türü</label>
                  <input data-testid="hasar-form-type" value={d.damage_type} onChange={(e) => setField("damage_type", e.target.value)} className={inputCls} placeholder="Çarpma, sürtme..." /></div>
                <div><label className={labelCls}>Kayıt Türü</label>
                  <select data-testid="hasar-form-rectype" value={d.type} onChange={(e) => setField("type", e.target.value)} className={inputCls}>
                    <option value="hasar">Hasar</option>
                    <option value="kaza">Kaza</option>
                  </select></div>
                <div><label className={labelCls}>Şiddet</label>
                  <select data-testid="hasar-form-severity" value={d.severity} onChange={(e) => setField("severity", e.target.value)} className={inputCls}>
                    <option value="low">Hafif</option>
                    <option value="medium">Orta</option>
                    <option value="severe">Ağır</option>
                  </select></div>
              </div>
              <div><label className={labelCls}>Yapılan İşlem *</label>
                <input data-testid="hasar-form-title" required value={d.title} onChange={(e) => setField("title", e.target.value)} className={inputCls} placeholder="Kapı onarımı, boya..." /></div>
            </>
          )}
          <div><label className={labelCls}>Açıklama</label>
            <textarea data-testid={`${testid}-form-description`} rows={2} value={d.description} onChange={(e) => setField("description", e.target.value)} className={inputCls} /></div>
          <div><label className={labelCls}>{kind === "bakim" ? "Tutar (₺)" : "Maliyet (₺)"}</label>
            <input data-testid={`${testid}-form-cost`} type="number" min="0" value={d.cost} onChange={(e) => setField("cost", e.target.value)} className={inputCls} /></div>
          <div>
            <label className={labelCls}>{kind === "bakim" ? "Fatura / Fotoğraf" : "Hasar Fotoğrafları"}</label>
            <input ref={fileRef} type="file" accept="image/*" multiple className="hidden"
              onChange={async (e) => {
                setUploading(true);
                try {
                  const paths = await uploadFiles([...e.target.files]);
                  setModal((m) => ({ ...m, data: { ...m.data, photos: [...m.data.photos, ...paths] } }));
                } catch (err) { toast.error(formatApiError(err)); }
                setUploading(false);
                e.target.value = "";
              }} />
            <button type="button" data-testid={`${testid}-form-upload`} onClick={() => fileRef.current?.click()} disabled={uploading}
              className="flex items-center gap-2 px-4 py-2.5 rounded-xl border border-dashed border-white/20 text-slate-300 text-sm hover:border-cyan-400/50 hover:text-cyan-300 transition-colors w-full justify-center disabled:opacity-50">
              <Upload className="w-4 h-4" /> {uploading ? "Yükleniyor..." : "Dosya Yükle"}
            </button>
            {d.photos.length > 0 && (
              <div className="mt-2 flex flex-wrap gap-2">
                {d.photos.map((p, i) => (
                  <div key={p} className="relative">
                    <img src={photoUrl(p)} alt="" className="w-16 h-12 object-cover rounded-lg border border-white/10" />
                    <button type="button" onClick={() => setModal((m) => ({ ...m, data: { ...m.data, photos: m.data.photos.filter((_, j) => j !== i) } }))}
                      className="absolute -top-1.5 -right-1.5 w-4 h-4 rounded-full bg-red-500 text-white flex items-center justify-center">
                      <X className="w-2.5 h-2.5" />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>
          <button data-testid={`${testid}-form-submit`} type="submit"
            className="w-full py-3 rounded-xl bg-cyan-400 text-slate-950 font-bold hover:bg-cyan-300 transition-all">
            {modal.record ? "Kaydı Güncelle" : "Kaydı Ekle"}
          </button>
        </form>
      </div>
    </div>
  );
}
